export default __webpack_public_path__ + "static/media/DeepakGupta.b78b301b.webp";